import { AppLocale, SUPPORTED_LOCALES } from './types';

export const DEFAULT_LOCALE: AppLocale = 'en';
export const FALLBACK_LOCALE: AppLocale = 'en';

const LOCALE_ALIASES: Record<string, AppLocale> = {
  zh: 'zh-Hans',
  'zh-cn': 'zh-Hans',
  'zh-hans': 'zh-Hans',
  'zh-hans-cn': 'zh-Hans',
};

export const normalizeLocale = (value?: string | null): AppLocale => {
  const raw = String(value || '').toLowerCase();
  if (raw in LOCALE_ALIASES) return LOCALE_ALIASES[raw];
  const language = raw.split(/[-_]/)[0];
  if (language in LOCALE_ALIASES) return LOCALE_ALIASES[language];
  return SUPPORTED_LOCALES.includes(language as AppLocale)
    ? (language as AppLocale)
    : FALLBACK_LOCALE;
};
